import React, { useCallback, useState } from 'react';
import { __, Message } from 'first-intl';
import { Button, Modal } from '@hugendubel/react-basic';
import { Store, useSub } from '../../store';

export type WSApiErrorModalProps = { errMessage: Message };
export const WSApiErrorModal: React.FC<WSApiErrorModalProps> = ({ errMessage }) => {
    const [pending, setPending] = useState(false);
    const triggerRetry = useSub(({ triggerRetry }) => triggerRetry);
    const onClick = useCallback(() => {
        setPending(!pending);
        Store.set({ triggerRetry: !triggerRetry });
    }, [pending, triggerRetry]);
    return (
        <div>
            <span>{__(errMessage)}</span>
            <div className="row buttons">
                <div className="col-xs-12">
                    <Button
                        className="btn btn-primary btn-lg"
                        label="get.authCode.retry.button"
                        type="button"
                        onClick={onClick}
                        loading={pending}
                    />
                </div>
            </div>
        </div>
    );
};

export const openWSApiErrorModal = ({ errMessage }: WSApiErrorModalProps): Promise<void> =>
    Modal.open(<WSApiErrorModal errMessage={errMessage} />, 'error.headline');
